import styled from 'styled-components'
import config from '../../config'

interface OnDemandStyleProps {
  mobileHeight: number
}

export const OnDemandStyle = styled.div<OnDemandStyleProps>`
  background-image: url('${config.assets.gallerium}');
  background-size: cover;
  height: ${(props) => props.mobileHeight}px;
  overflow: hidden;

  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.2);
  }

  .page-content {
    .grid-container {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fit, 35%);
      grid-auto-rows: max-content;
      justify-content: center;
      text-align: center;
      position: relative;
      overflow-y: scroll;
      height: ${(props) => props.mobileHeight - 120}px;
    }

    .grid-container-mobile {
      position: relative;
      overflow-y: scroll;
      height: ${(props) => props.mobileHeight - 120}px;
    }

    .area-grid-container {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fit, 25%);
      grid-auto-rows: max-content;
      text-align: center;
      position: relative;
      overflow-y: scroll;
      h5 {
        font-size: 16px;
        font-weight: bold;
        margin-left: 1em;
        text-align: left;
        margin-top: 20px;
        color: darkred;
        text-transform: uppercase;
        @media screen and (min-width: 768px) {
          margin-left: 2em;
        }
      }
    }

    h5 {
      margin-top: 20px;
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
      text-align: left;
      color: darkred;
      text-transform: uppercase;
      @media screen and (min-width: 768px) {
        margin-left: 2em;
      }
    }

    .card-thumbnail {
      display: block;
      cursor: pointer;
      position: relative;
      text-align: center;
      color: black;
      font-weight: 600;
      text-decoration: none;
      font-size: 16px;
      img {
        transition: 150ms ease-in;
        border-radius: 18px;
        width: 90%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        margin-bottom: 20px;
        @media screen and (min-width: 768px) {
          width: 100%;
          border-radius: 30px;
        }
      }
    }

    .area-card-thumbnail {
      display: block;
      cursor: pointer;
      position: relative;
      text-align: center;
      color: white;
      font-weight: 600;
      text-decoration: none;
      font-size: 20px;
      img {
        transition: 150ms ease-in;
        width: 80%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      }
    }
  }

  // header
  .back-btn {
    height: 60px;
    padding: 0 20px;
    backdrop-filter: blur(22px);
    background-color: rgba(255, 255, 255, 0.3);
    font-weight: bold;
    color: #f85d49;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    text-decoration: none;
    .back-icon {
      display: flex;
      width: 30px;
      flex-direction: column;
      img,
      svg {
        transition: 100ms linear;
        height: 24px;
      }
      .icon-label {
        text-align: left;
        font-size: 1px;
        opacity: 0;
      }
    }
    span {
      font-size: 18px;
      font-style: italic;
      margin-left: 1em;
      color: #f85d49;
    }
  }
`
